var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.744 0.779577L15.2199 0.25548C15.0552 0.0906668 14.8356 0 14.6012 0C14.3668 0 14.1471 0.0906668 13.9824 0.25548L6.61815 7.61964L2.01704 3.01841C1.85236 2.85385 1.63265 2.76306 1.39824 2.76306C1.16397 2.76306 0.94439 2.85385 0.779577 3.01841L0.25535 3.54237C0.0905366 3.70745 0 3.92728 0 4.16143C0 4.39571 0.0905366 4.61541 0.25535 4.78023L5.45028 9.97489C5.45717 9.98465 5.46446 9.99376 5.47291 10.0021L5.99714 10.5176C6.16182 10.6818 6.38153 10.7638 6.61776 10.7638H6.62049C6.85502 10.7638 7.07473 10.6818 7.23915 10.5176L7.76351 9.99753C7.77197 9.9892 7.77912 9.98231 7.78341 9.97528L15.7439 2.01561C16.0853 1.67493 16.0853 1.12065 15.744 0.779577Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.dcd35841189512ebc5345ae22822f4e7.svg";
export { ForwardRef as ReactComponent };